module.exports = __webpack_public_path__ + "static/media/py.bbc22e41.svg";